import { axiosBase, errorHandler } from "./axios";

const getSubscriptionPlan = (planName: string) => {
  return axiosBase
    .get(`subscriptions/getPlan/${planName}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const createSubscription = (data: any) => {
  return axiosBase
    .post("subscriptions/create", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getSubscriptionStatus = (subscriptionId: string) => {
  return axiosBase
    .get(`subscriptions/status/${subscriptionId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getOrderStatus = (orderId: string) => {
  return axiosBase
    .get(`subscriptions/order-status/${orderId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const syncPlans = () => {
  return axiosBase
    .post("subscriptions/sync-plans")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getAllPlans = () => {
  return axiosBase
    .get("subscriptions/getAllPlan")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getUserSubscriptionStatus = () => {
  return axiosBase
    .get("subscriptions/user-status")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const subscriptionService = {
  getSubscriptionPlan,
  createSubscription,
  getSubscriptionStatus,
  getOrderStatus,
  syncPlans,
  getAllPlans,
  getUserSubscriptionStatus
};
